<template>
  <div>
    <el-dialog
      :visible.sync="showModal"
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <span slot="title" class="modal-title">REENVIAR LEMBRETE DE ASSINATURA</span>
      <el-alert
        title="Confirmação"
        type="warning"
        :description="descricao"
        show-icon
        :closable="false"
      />
      <span slot="footer">
        <el-button type="primary" :loading="loadingSave" @click="enviar">Enviar</el-button>
        <el-button type="danger" @click="showModal = false">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Rest from "common/rest";

export default {
  name: "lembrete-assinatura",
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loadingSave: false,
      showModal: false,
    };
  },
  watch: {
    "parent.showLembreteAssinatura"(val) {
      this.showModal = val;
    },
    showModal(val) {
      if (!val) {
        this.parent.showLembreteAssinatura = false;
      }
    },
  },
  computed: {
    descricao() {
      if (!this.parent.consulta) return "";
      var funcionario = this.parent.consulta.funcionario
        ? this.parent.consulta.funcionario.nome
        : "o funcionário";
      return (
        "Deseja reenviar o lembrete de assinatura digital do ASO da consulta " +
        this.parent.consulta.id_con +
        " para " +
        funcionario +
        "?"
      );
    },
  },
  methods: {
    enviar() {
      var consulta = this.parent.consulta;
      var telefone = consulta.funcionario ? consulta.funcionario.tel_cel : null;
      var nome = consulta.funcionario ? consulta.funcionario.nome : null;

      if (!telefone) {
        this.$notify({
          title: "Erro",
          message: "Funcionário não possui celular cadastrado.",
          type: "error",
        });
        return;
      }

      var url = "/" + this.cliente.logged.url + "/funcionario/aso/assinar/" + consulta.id_con;

      this.loadingSave = true;

      this.post(`/${this.cliente.logged.url}/funcionario/aso/disparar-whatsapp-lembrete-assinar`, {
        telefone: telefone,
        nome: nome,
        url: url,
        id_con: consulta.id_con,
      })
        .then((result) => {
          result = result[0];
          this.loadingSave = false;

          if (result.status == 200 && result.data && result.data.success) {
            this.$notify({
              title: "Sucesso",
              message: "Lembrete de assinatura reenviado com sucesso!",
              type: "success",
            });
          } else {
            this.$notify({
              title: "Erro",
              message: "Não foi possível reenviar o lembrete. Tente novamente. Se o erro persistir contate o suporte.",
              type: "error",
            });
          }

          this.showModal = false;
        })
        .catch((e) => {
          console.log(e);
          this.loadingSave = false;
          this.$notify({
            title: "Erro",
            message: "Não foi possível reenviar o lembrete. Tente novamente.",
            type: "error",
          });
          this.showModal = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// lembrete-assinatura.vue?650966a7